import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { pushRoute } from '../../lib/router.js';
import SubHeader from '../../components/SubHeader.jsx';
import Empty from '../../components/Empty.jsx';
import { loadingContent } from '../../components/EmptyStates.jsx';
import PortfolioViewHeader from '../../components/headers/PageHeaders/Portfolio/PortfolioViewHeader.jsx';
import PortfolioOverview from '../../components/portfolio/PortfolioOverview.jsx';
import {
  deletePortfolio,
  retrievePortfolio,
  selectPortfolio,
  selectRetrievePortfolioState,
} from '../../modules/portfolio.js';
import PortfolioHeader from '../../components/headers/PageHeaders/Portfolio/PortfolioHeader.jsx';
import {
  retrieveProjectStatuses,
  selectProjectStatusesWithArchived,
  selectRetrieveStatusesState,
} from '../../modules/projectStatuses.js';

import {
  deleteProject,
  retrieveIsShowAlertOnDelete,
  retrieveProjects,
} from '../../modules/projects.js';
import PortfoliosActionDropdown from '../../components/portfolio/PortfoliosActionDropdown.jsx';
import { selectOrganization } from '../../modules/organizations.js';
import { selectUserPermissions } from '../../modules/auth.js';
import { getOrgTermsContent } from '../../content/utils.js';

const mapStateToProps = (state, ownProps) => {
  const retrieveSuccess = [
    selectRetrievePortfolioState,
    selectRetrieveStatusesState,
  ].every((select) => select(state).success);

  return {
    portfolioId: ownProps.portfolioId,
    portfolio: selectPortfolio(ownProps.portfolioId)(state),
    projectStatuses: selectProjectStatusesWithArchived(state),
    organization: selectOrganization(state),
    permissions: selectUserPermissions(state),
    retrieveSuccess,
  };
};

const mapDispatchToProps = {
  retrievePortfolio,
  retrieveProjectStatuses,
  retrieveProjects,
  retrieveIsShowAlertOnDelete,
  deleteProject,
  deletePortfolio,
};

const PortfolioInfoContainer = ({
  slug,
  portfolioId,
  portfolio,
  permissions,
  organization,
  retrievePortfolio,
  projectStatuses,
  retrieveProjectStatuses,
  retrieveSuccess,
  deletePortfolio,
}) => {
  const location = useLocation();
  const route = location.pathname;

  const onDeletePortfolio = (portfolioId) => {
    if (!window.confirm(getOrgTermsContent('deletePortfolioDescription')))
      return;
    deletePortfolio(portfolioId).then(() => pushRoute('projects/index'));
  };

  useEffect(() => {
    retrievePortfolio(portfolioId);
    retrieveProjectStatuses({ archived: true });
  }, []);

  if (!retrieveSuccess || !portfolio.project_status_id)
    return <Empty simplified content={loadingContent} />;

  return (
    <React.Fragment>
      <PortfolioHeader portfolio={portfolio} portfolioTabs />
      <SubHeader flexJustify small>
        <div className="flex">
          <h2>{portfolio.name}</h2>
        </div>
        <div className="flex flex-1 flex-end">
          <div className="flex">
            {portfolio.permissions ? (
              <PortfoliosActionDropdown
                slug={slug}
                portfolioId={portfolioId}
                organization={organization}
                onDeletePortfolio={onDeletePortfolio}
                portfolio={portfolio}
              />
            ) : null}
          </div>
        </div>
      </SubHeader>
      <PortfolioViewHeader
        portfolio={portfolio}
        projectStatuses={projectStatuses}
      />
      <PortfolioOverview portfolio={portfolio} />
    </React.Fragment>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PortfolioInfoContainer);
